module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_13.92042c51.jpg";